import React, { useCallback, useMemo } from "react";
import { IconButton, ButtonBase, CircularProgress } from "@material-ui/core";
import PageBox from "../../components/PageBox/PageBox.component";
import styles from "./Style.module.css";
import Constants from "../../config/constants";
import StatusPill from "../../components/Status/StatusPill.component";
import FilterComponent from "../../components/Filter/Filter.component";
import CustomDatePicker from "../../components/FormFields/DatePicker/CustomDatePicker";
import { useSelector } from "react-redux";
import VisibilityIcon from "@material-ui/icons/Visibility";
import GetAppIcon from "@material-ui/icons/GetApp";
import Datatables from "../../components/Datatables/datatables";
import IdCardPreviewDialog from "./Dialog/IdCardPreviewDialog.view";
import useUpdatedIdCardsHook from "./UpdatedEmpIdCards.hook";

const UpdatedIdCardsListView = ({ location }) => {
  const {
    handlePageChange,
    handleFilterDataChange,
    handleSearchValueChange,
    handleRowSize,
    handleSortOrderChange,
    isCalling,
    openPreview,
    configFilter,
    changeTextData,
    form,
    formatDateToDisplay,
    listData,
    selectedCard,
    handleView,
    handleIdDownload,
    handleDownload,
    isLoading,
    handleToggle,
  } = useUpdatedIdCardsHook({ location });

  const renderStatus = useCallback((status) => {
    return <StatusPill status={status} />;
  }, []);

  const {
    data,
    all: allData,
    currentPage,
    is_fetching: isFetching,
  } = useSelector((state) => state.updated_id_card);

  const tableStructure = useMemo(() => {
    return [
      {
        key: "name",
        label: "EMPLOYEE NAME",
        sortable: false,
        render: (value, all) =>   <div className={styles.imgWrap}>
            <div>
              <img src={all?.image} className={styles.imgClass} />
            </div>
            <div>
              {all?.name}
              <div>{all?.emp_code}</div>
            </div>
          </div>,
      },
      {
        key: "location",
        label: "LOCATION",
        sortable: false,
        render: (value, all) => <div>{all?.location_name}</div>,
      },
      {
        key: "designation",
        label: "DESIGNATION",
        sortable: false,
        render: (temp, all) => <div>{all?.designation}</div>,
      },
      {
        key: "department",
        label: "DEPT. & SUB DEPT.",
        sortable: false,
        render: (temp, all) => (
          <div>
            {all?.department} & {all?.subdepartment}
          </div>
        ),
      },
      {
        key: "is_id_card_printed",
        label: "Is Id card printed",
        sortable: false,
        render: (temp, all) => (
          <div style={{ color: all?.is_id_card_printed ? "green" : "red" }}>
            {all?.is_id_card_printed ? "PRINTED" : "NOT PRINTED"}
          </div>
        ),
      },
      {
        key: "doj",
        label: "D.O.J",
        sortable: false,
        render: (temp, all) => <div>{formatDateToDisplay(all?.doj)}</div>,
      },
      {
        key: "status",
        label: "STATUS",
        sortable: false,
        render: (temp, all) => <div>{renderStatus(all?.status)}</div>,
      },
      {
        key: "month3",
        label: "ACTION",
        sortable: false,
        render: (temp, all) => (
          <div className={styles.dFlex}>
            <IconButton
              className={"tableActionBtn"}
              color="secondary"
              disabled={isCalling}
              onClick={() => {
                handleView(all?.id_card);
              }}
            >
              <VisibilityIcon fontSize={"small"} />
            </IconButton>

            <IconButton
              className={"tableActionBtn"}
              color="secondary"
              disabled={isCalling}
              onClick={() => {
                handleIdDownload(all?.id_card);
              }}
            >
              <GetAppIcon fontSize={"small"} />
            </IconButton>
          </div>
        ),
      },
    ];
  }, []);

  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      onRowSizeChange: handleRowSize,
    };

    const datatable = {
      ...Constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: data,
      count: allData.length,
      page: currentPage,
    };

    return { datatableFunctions, datatable };
  }, [
    allData,
    tableStructure,
    handleSortOrderChange,
    handlePageChange,
    handleRowSize,
    data,
    currentPage,
  ]);
  console.log("allData >> ", allData, data);

  return (
    <div>
      <PageBox>
        <div className={styles.headerContainer}>
          <div>
            <span className={styles.title}>Updated Emp ID Cards</span>
            <div className={styles.newLine} />
          </div>
        </div>

        <div className={styles.formFlex}>
          <div className={styles.formGroup}>
            <CustomDatePicker
              clearable
              label={"Update Start Date"}
              onChange={(date) => {
                changeTextData(date, "start_date");
              }}
              value={form?.start_date}
              maxDate={new Date()}
              // isError={errorData?.pro_start_date}
            />
          </div>
          <div className={styles.formGroup}>
            <CustomDatePicker
              clearable
              label={"Update End Date"}
              maxDate={new Date()}
              onChange={(date) => {
                changeTextData(date, "end_date");
              }}
              value={form?.end_date}
            />
          </div>
          <div className={styles.rightFlex}>
            <ButtonBase
              className={styles.download}
              onClick={handleDownload}
              disabled={isLoading}
            >
              {isLoading ? (
                <CircularProgress size={20} color="success" />
              ) : (
                "DOWNLOAD"
              )}
            </ButtonBase>
          </div>
        </div>
        <div>
          <div>
            <FilterComponent
              is_progress={isCalling}
              // filters={configFilter}
              handleSearchValueChange={handleSearchValueChange}
              handleFilterDataChange={handleFilterDataChange}
            />
            <Datatables
              {...tableData.datatable}
              {...tableData.datatableFunctions}
            />
          </div>
        </div>
      </PageBox>

      <IdCardPreviewDialog
        isOpen={openPreview}
        handleClose={handleToggle}
        data={selectedCard}
        handleDownload={handleDownload}
      />
    </div>
  );
};

export default UpdatedIdCardsListView;
